const serviceApp = () => import("@/views/downLoad/serviceApp.vue");
const deviceApp = () => import("@/views/downLoad/deviceApp.vue");
const padApp = () => import("@/views/downLoad/padApp.vue");
const Login = () => import("@/views/login");
const productDetail = () => import("@/views/productDetail");
const salesList = () => import("@/views/salesList");
const salesDetail = () => import("@/views/salesDetail");
const auth = () => import("@/views/auth");
const paper = () => import("@/views/paper");
const productInfo = () => import("@/views/productInfo");
// const home = () => import("@/views/home");
const userAgreement = () => import("@/views/agreement/userAgreement");
const privacyAgreement = () => import("@/views/agreement/privacyAgreement");
const platformIntroduction = () =>
  import("@/views/introduction/platformIntroduction");
const law = () => import("@/views/introduction/law");
const enterprises = () => import("@/views/introduction/enterprises");
const merchants = () => import("@/views/introduction/merchants");
const idCode = () => import("@/views/idCode");
const serviceAgreement = () => import("@/views/agreement/serviceAgreement");
const logisticsPDF = () => import("@/page/logisticsPDF/index");
const market = () => import("@/views/market");
const kLine = () => import("@/views/kLine");
const notFound = () => import("@/page/notFound");
const appreciate = () => import("@/views/appreciate");
const appreciateLogin = () => import("@/views/appreciate/login.vue");
const appreciateAgreement = () => import("@/views/appreciate/agreement.vue");
const article = () => import("@/views/article/index.vue");
const articleJSTCourse = () => import("@/views/article/jstCourse.vue");
const statistics = () => import("@/views/statistics/index.vue");
const goldProductDetail = () => import("@/views/goldProductDetail/index.vue");
const recyle = () => import("@/views/goldProductDetail/recyle/index.vue");
const trial = () => import("@/views/trial/index.vue");
// const productDetail = () => import("@/views/productDetail");
const routes = [
  { path: "/", redirect: "/salesList" },
  // { path: "/home", component: home },
  { path: "/login", component: Login },
  { path: "/productDetail", component: productDetail },
  {
    path: "/salesList",
    component: salesList,
    meta: {
      keepAlive: true,
    },
  },
  { path: "/salesDetail", component: salesDetail },
  { path: "/statistics", component: statistics },
  { path: "/accredit", component: auth },
  { path: "/paper", component: paper },
  { path: "/productInfo/", component: productInfo, name: "productInfo" },
  { path: "/app", component: serviceApp },
  { path: "/device", component: deviceApp },
  { path: "/pad", component: padApp },
  {
    path: "/legal-agreement/gm/terms/user-agreement",
    component: userAgreement,
  },
  {
    path: "/legal-agreement/gm/terms/privacy-agreement",
    component: privacyAgreement,
  },
  {
    path: "/legal-agreement/gm/terms/service-agreement",
    component: serviceAgreement,
  },
  {
    path: "/gm/introduction/platformIntroduction",
    component: platformIntroduction,
  },
  { path: "/gm/introduction/law", component: law },
  { path: "/gm/introduction/enterprises", component: enterprises },
  { path: "/gm/introduction/merchants", component: merchants },
  { path: "/idCode", component: idCode },
  { path: "/exportLogisticsPDF", component: logisticsPDF },
  {
    path: "/market",
    component: market,
    meta: {
      keepAlive: true,
    },
  },
  { path: "/kLine", component: kLine },
  { path: "/p/:barCode", component: productDetail },
  { path: "/p/:barCode/:skuSn", component: productDetail },
  { path: "/pd", component: productDetail },
  {
    path: "/appreciate",
    component: appreciate,
    redirect: "/appreciate/login",
    children: [
      { path: "login", component: appreciateLogin },
      { path: "agreement", component: appreciateAgreement },
    ],
  },
  {
    path: "/article/:id",
    component: article,
  },
  {
    path: "/articleJST/course",
    component: articleJSTCourse,
  },
  {
    path: "/g/:barCode",
    component: goldProductDetail,
  },
  {
    path: "/recyle",
    component: recyle,
  },
  {
    path: "/trial",
    component: trial,
  },
  { path: "*", component: notFound },
];
export default routes;
